// Promotion Mutations

export const updatePromotionList = (state, payload) => {
  state.promotionList = payload
}

export const fetchPromotionInfo = (state, payload) => {
  state.promotionInfo = payload
}
